import { RefreshCw, Globe } from "lucide-react";
import { useRegion } from "@/context/RegionContext";
import { fmt } from "@/lib/api";

export default function RegionSwitcher() {
  const { regions, active, setActive, fx, refreshFx } = useRegion();
  const main = regions.filter((r) => r.code !== "GLOBAL");
  const pairs = main.map((r) => r.currency).filter((c, i, a) => c !== "USD" && a.indexOf(c) === i);

  return (
    <div className="flex items-center gap-4" data-testid="region-switcher">
      <div className="flex border border-kl-line">
        <button onClick={() => setActive("ALL")} data-testid="region-tab-ALL" className={`h-8 px-3 text-[11px] font-mono uppercase tracking-wider flex items-center gap-1.5 transition-colors duration-150 ${active === "ALL" ? "bg-white text-kl-black" : "text-kl-muted hover:text-white hover:bg-kl-surface"}`}><Globe size={12} /> All</button>
        {regions.map((r) => (
          <button key={r.code} onClick={() => setActive(r.code)} data-testid={`region-tab-${r.code}`} title={`${r.name} · ${r.currency}`}
            className={`h-8 px-3 text-[11px] font-mono uppercase tracking-wider border-l border-kl-line transition-colors duration-150 ${active === r.code ? "bg-kl-green text-kl-black" : "text-kl-muted hover:text-white hover:bg-kl-surface"}`}>{r.code === "GLOBAL" ? "Global" : r.name}</button>
        ))}
      </div>
      {fx?.rates && (
        <button onClick={refreshFx} data-testid="fx-ticker" title={`Rates ${fx.stale ? "(stale) " : ""}updated ${fmt.time(fx.fetched_at)} · click to refresh`} className="hidden xl:flex items-center gap-2 font-mono text-[11px] text-kl-muted hover:text-white transition-colors duration-150">
          <span className={fx.stale ? "text-kl-inactive" : "text-kl-green"}>FX</span>
          {pairs.map((c) => <span key={c}>1 USD = {fx.rates[c]?.toFixed(2)} {c}</span>)}
          <RefreshCw size={11} />
        </button>
      )}
    </div>
  );
}
